//
//
//
//

export default {
  name: 'BaseCountDown',
  props: {
    endTime: {
      type: Number,
      default: 0,
    },
    formateType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      time: '',
      flag: false,
      localtime: this.endTime,
    }
  },
  mounted() {
    const time = setInterval(() => {
      if (this.flag === true) {
        clearInterval(time)
      }
      if (this.formateType === 1) {
        this.timeDown()
      } else {
        this.anotherDown()
      }
    }, 1000)
  },
  methods: {
    timeDown() {
      const leftTime = this.localtime
      const d = parseInt(leftTime / (24 * 60 * 60))
      const h = this.formate(parseInt((leftTime / (60 * 60)) % 24))
      const m = this.formate(parseInt((leftTime / 60) % 60))
      const s = this.formate(parseInt(leftTime % 60))
      if (leftTime <= 0) {
        this.flag = true
        this.$emit('time-end')
      } else {
        this.localtime = this.localtime - 1
      }
      this.time = `${d}:${h}:${m}:${s}`
    },
    anotherDown() {
      const leftTime = this.localtime
      const h = this.formate(parseInt(leftTime / (60 * 60)))
      const m = this.formate(parseInt((leftTime / 60) % 60))
      const s = this.formate(parseInt(leftTime % 60))
      if (leftTime <= 0) {
        this.flag = true
        this.$emit('time-end')
      } else {
        this.localtime = this.localtime - 1
      }
      this.time = `${h}:${m}:${s}`
    },
    formate(time) {
      if (time >= 10) {
        return time
      } else {
        return `0${time}`
      }
    },
  },
}
